import { useEffect, useRef } from "react";

export default function ScrollProgressBar() {
  const fillRef = useRef<HTMLDivElement>(null);
  const tipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let rafId: number;

    const update = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docHeight > 0 ? scrollTop / docHeight : 0;

      if (fillRef.current) {
        fillRef.current.style.transform = `scaleY(${pct})`;
      }
      if (tipRef.current) {
        tipRef.current.style.top = `${pct * 100}%`;
      }
    };

    const onScroll = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(update);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    update();

    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(rafId);
    };
  }, []);

  return (
    <div
      className="fixed left-0 top-0 z-[9999] w-[6px]"
      style={{ height: "100vh", pointerEvents: "none" }}
      aria-hidden="true"
    >
      {/* Track */}
      <div className="absolute inset-0" style={{ backgroundColor: "rgba(255,255,255,0.04)" }} />
      {/* Fill — scaleY from top, GPU-accelerated */}
      <div
        ref={fillRef}
        className="absolute left-0 top-0 w-full h-full origin-top will-change-transform"
        style={{
          transform: "scaleY(0)",
          background: "linear-gradient(to bottom, #D4A853, #C8922A)",
          borderRadius: "0 0 2px 2px",
        }}
      />
      {/* Glowing tip */}
      <div
        ref={tipRef}
        className="absolute left-0 w-full will-change-transform"
        style={{
          top: "0%",
          transform: "translateY(-50%)",
          height: "16px",
          background: "radial-gradient(ellipse at left, rgba(212,168,83,0.8) 0%, transparent 80%)",
        }}
      />
    </div>
  );
}
